import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { REVIEW } from '../../../../../../constants/queryKeys';
import { ReviewCriteriaFindResponseDto } from '../../types/ReviewCriteriaTypes';
import { QueryOptions } from '../../../../../../types/query/useQuery';
import CategoryApi from '../../../../../../lib/api/category/CategoryApi';

type UseReviewCriteriaQuery<SelectResultType> = {
  id?: number;
  options?: QueryOptions<ReviewCriteriaFindResponseDto, unknown, SelectResultType>;
};

export const useReviewCriteriaQuery = <SelectResultType>({
  id,
  options,
}: UseReviewCriteriaQuery<SelectResultType>): UseQueryResult<SelectResultType, unknown> => {
  return useQuery<ReviewCriteriaFindResponseDto, unknown, SelectResultType>(
    [...REVIEW.CATEGORY_CRITERIA, id],
    () => CategoryApi.getCategoryReviewCriteria(id as number),
    {
      ...options,
      enabled: !!id,
    },
  );
};
